import React from 'react';
import { motion } from 'framer-motion';
import { useForm, ValidationError } from '@formspree/react';
import { SectionLabel, SectionHeading } from './ui/UI';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function SnapshotForm() {
  const [state, handleSubmit] = useForm('mykvgpkn'); // Using same formspree endpoint for now
  const {
    submitting,
    succeeded
  } = state;
  return <section id="snapshot-form" className="relative w-full py-32 border-t border-white/5" data-id="element-1360">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-1361">
        <SectionLabel number="01" label="Validation Snapshot" className="mb-8" data-id="element-1362" />

        <div className="mb-12" data-id="element-1363">
          <SectionHeading size="lg" data-id="element-1364">Request a Snapshot.</SectionHeading>
          <p className="text-lg text-white/65 leading-relaxed mt-4" data-id="element-1365">
            Get an initial view of your continuous validation readiness in
            minutes. No demo call required.
          </p>
        </div>

        {succeeded ? <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="rounded-2xl bg-gradient-to-br from-[#1a8fd4]/10 to-[#0a0d12] border border-[#1a8fd4]/30 p-12 text-center" data-id="element-1366">
            <CheckCircle2 className="w-16 h-16 text-[#1a8fd4] mx-auto mb-6" data-id="element-1367" />
            <h3 className="text-2xl font-semibold text-white mb-3" data-id="element-1368">
              Request received.
            </h3>
            <p className="text-base text-white/65 mb-5 max-w-md mx-auto" data-id="element-1369">
              We'll review your request and follow up with next steps to start
              your Validation Snapshot.
            </p>
          </motion.div> : <form onSubmit={handleSubmit} className="rounded-2xl bg-[#070a0e] border border-white/5 p-8 md:p-10" data-id="element-1370">
            <div className="space-y-4 mb-6" data-id="element-1371">
              <Field id="email" name="email" type="email" label="Work email *" required placeholder="you@company.com" data-id="element-1372" />
              <Field id="company" name="company" label="Company *" required placeholder="Your company" data-id="element-1373" />
              <Field id="website" name="website" label="Company website" placeholder="company.com" data-id="element-1374" />
              <SelectField id="validation_need" name="validation_need" label="Primary validation need *" options={['Attack-path report', 'AI app validation', 'Fix verification', 'Customer security review evidence', 'SOC 2 / ISO readiness', 'Cyber-insurance readiness', 'Other']} data-id="element-1375" />
            </div>

            <ValidationError errors={state.errors} className="text-sm text-red-400 mb-4" data-id="element-1376" />

            <button type="submit" disabled={submitting} className="group w-full flex items-center justify-between gap-2 px-6 py-4 bg-white text-black font-medium rounded-full hover:bg-white/90 transition-colors disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-1377">
              <span data-id="element-1378">
                {submitting ? 'Requesting…' : 'Request Validation Snapshot'}
              </span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" data-id="element-1379" />
            </button>
          </form>}
      </div>
    </section>;
}
function Field({
  id,
  name,
  label,
  type = 'text',
  placeholder,
  required
}: {
  id: string;
  name: string;
  label: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
}) {
  return <div data-id="element-1380">
      <label htmlFor={id} className="block font-mono text-xs uppercase tracking-widest text-white/40 mb-2" data-id="element-1381">
        {label}
      </label>
      <input id={id} name={name} type={type} required={required} placeholder={placeholder} className="w-full bg-[#050608] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-[#1a8fd4]/50 focus:ring-1 focus:ring-[#1a8fd4]/50 transition-all" data-id="element-1382" />
    </div>;
}
function SelectField({
  id,
  name,
  label,
  options
}: {
  id: string;
  name: string;
  label: string;
  options: string[];
}) {
  return <div data-id="element-1383">
      <label htmlFor={id} className="block font-mono text-xs uppercase tracking-widest text-white/40 mb-2" data-id="element-1384">
        {label}
      </label>
      <select id={id} name={name} required className="w-full bg-[#050608] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#1a8fd4]/50 focus:ring-1 focus:ring-[#1a8fd4]/50 transition-all appearance-none" data-id="element-1385">
        <option value="" data-id="element-1386">Select…</option>
        {options.map(o => <option key={o} value={o} data-id="element-1387">
            {o}
          </option>)}
      </select>
    </div>;
}